import type { FetchConfig } from '@nlo/nuxt-common/api/helper-types';
import type { paths } from '~/generated/krasloten-api';

/**
 * Api for retrieving XSRF tokens.
 */
export interface TokenApi {
	/**
	 * Fetch a XSRF token from the server.
	 * This will re-use results from previous requests if the response was successful.
	 */
	getXSRFToken(): Promise<string>;
}

export function createTokenApi(fetchConfig: FetchConfig): TokenApi {
	const client = fetchConfig.createClient<paths>();

	let getTokenPromiseCache: Promise<string> | undefined;

	return {
		getXSRFToken(): Promise<string> {
			if (getTokenPromiseCache) {
				return getTokenPromiseCache;
			}
			getTokenPromiseCache = client.GET('/api/token');
			return getTokenPromiseCache;
		},
	};
}
